<template>
  <v-container class="fill-height pa-0">
    <v-row class="fill-height ma-0" justify="space-around">
      <v-col xs="4" sm="4" md="6" lg="6" class="pa-0">
        <v-img
          :src="require('@/assets/stars_anim.webp')"
          :lazy-src="require('@/assets/stars_blur.webp')"
          :width="`${ bgWidth }`"
        >
          <v-sheet
            color="transparent"
            class="overflow-y-auto align-self-center"
            :max-height="`${ bgHeight }`"
          >
            <div
              class="d-flex flex-column justify-space-around"
              style="margin-top: 100px"
            >
              <v-card
                class="mx-auto justify-start card-shadow"
                :width="`${cardWidth}%`"
                outlined
                tile
              >
                <v-avatar size="100" class="robot">
                  <v-img
                    aspect-ratio="1"
                    alt="user"
                    :src="require('@/assets/robot.webp')"/>
                </v-avatar>
                <v-card
                  class="mx-auto d-flex flex-column justify-start align-content-space-around"
                  flat
                  min-height="140px"
                >
                  <v-card-title
                    class="mx-auto pt-11 welcome welcome_in"
                    :class="{ welcome_out: sendButtonClick }"
                  >
                    WELCOME
                  </v-card-title>

                  <v-card-subtitle
                    class="mx-auto subtitle-2 mb-4 px-10 text-center black--text message message_in"
                    :class="{ message_out: sendButtonClick, 'red--text': error }"
                  >
                    {{ this.info_message}}
                  </v-card-subtitle>
                </v-card>
                <v-form
                  dense
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="form-custom"
                >
                  <v-text-field
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="firstName"
                    label="First Name"
                    :rules="nameRules"
                    dense
                    required
                    outlined
                  ></v-text-field>
                  <v-text-field
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="lastName"
                    label="Last Name"
                    :rules="nameRules"
                    dense
                    required
                    outlined
                  ></v-text-field>
                  <v-text-field
                    class="label-left input--dense rounded-lg"
                    :class="{ red_label: error_type === 'email' }"
                    persistent-placeholder
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    v-model="password"
                    :rules="passwordRules"
                    :append-icon="passShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="passShow ? 'text' : 'password'"
                    hint="At least 6 characters"
                    @click:append="passShow = !passShow"
                    class="label-left input--dense rounded-lg"
                    :class="{ red_label: error_type === 'password' }"
                    persistent-placeholder
                    label="Password"
                    outlined
                    dense
                    validate-on-blur
                  ></v-text-field>
                  <v-text-field
                    ref="confirmPassword"
                    v-model="confirmPassword"
                    :rules="rules"
                    :append-icon="confirmShow ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="confirmShow ? 'text' : 'password'"
                    @click:append="confirmShow = !confirmShow"
                    class="label-left input--dense rounded-lg"
                    :class="{ red_label: error_type === 'password' }"
                    persistent-placeholder
                    label="Confirm Password"
                    required
                    outlined
                    dense
                    :error="dont_match"
                  ></v-text-field>
                  <v-autocomplete
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="occupation"
                    :items="occupations"
                    :rules="occupationRules"
                    label="Occupation"
                    required
                    outlined
                    dense
                  ></v-autocomplete>
                  <v-text-field
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="age"
                    :rules="ageRules"
                    label="Age"
                    required
                    outlined
                    dense
                    type="number"
                  ></v-text-field>
                  <v-text-field
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="company"
                    label="Company"
                    outlined
                    dense
                  ></v-text-field>
                  <v-autocomplete
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="industry"
                    :items="industries"
                    label="Industry"
                    outlined
                    dense
                  ></v-autocomplete>
                  <v-autocomplete
                    class="label-left input--dense rounded-lg"
                    persistent-placeholder
                    v-model="nationality"
                    :items="nationalities"
                    :rules="[ v => !!v || 'Nationality is required']"
                    label="Nationality"
                    outlined
                    dense
                  ></v-autocomplete>
                </v-form>
              </v-card>
              <v-btn
                outlined
                @click="submit()"
                :loading="this.isAccountCreating"
                class="mx-auto my-10 text-lg-center button-font"
                :width="`${cardWidth}%`"
                :disabled="!valid"
                elevation="6"
                rounded
                fab
              >
                Send
              </v-btn>
            </div>
          </v-sheet>
        </v-img>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from "vuex";
  import { REGISTER } from "@/store/_actiontypes";
  import store from "@/store";
  import {SET_USER} from "@/store/_mutationtypes";

  export default {
    name: 'RegisterForm',

    data: () => ({
      valid: true,
      firstName: '',
      lastName: '',
      nameRules: [
        v => !!v || 'Name is required',
/*        v => (v && v.length <= 20) || 'Name must be less than 20 characters',*/
      ],
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
      ],
      occupation: '',
      occupations: [{'header': 'Healthcare Practitioners and Technical Occupations:'},
      'Chiropractor', 'Dentist', 'Dietitian or Nutritionist', 'Optometrist', 'Pharmacist', 'Pharmacist', 'Physician Assistan', 'Podiatrist', 'Registered Nurse', 'Therapist', 'Veterinarian', 'Health Technologist or Technician', 'Other Healthcare Practitioners and Technical Occupation',
        {'header': 'Healthcare Support Occupations: '},
        'Nursing, Psychiatric, or Home Health Aide', 'Occupational and Physical Therapist Assistant or Aide', 'Other Healthcare Support Occupation',
        {'header': 'Business, Executive, Management, and Financial Occupations:'},
        'Chief Executive', 'General and Operations Manager', 'Advertising, Marketing, Promotions, Public Relations, and Sales Manager',
        'Operations Specialties Manager (e.g., IT or HR Manager)', 'Construction Manager', 'Engineering Manager', 'Accountant, Auditor', 'Business Operations or Financial Specialist', 'Business Owner', 'Other Business, Executive, Management, Financial Occupation',
        {'header': 'Architecture and Engineering Occupations:'},
        'Architect, Surveyor, or Cartographer',
        'Engineer',
        'Other Architecture and Engineering Occupation',
        {'header': 'Education, Training, and Library Occupations:'},
        'Postsecondary Teacher (e.g., College Professor)',
        'Primary, Secondary, or Special Education School Teacher',
        'Other Teacher or Instructor',
        'Other Education, Training, and Library Occupation',
        {'header': 'Other Professional Occupations:'},
        'Arts, Design, Entertainment, Sports, and Media Occupations',
        'Computer Specialist, Mathematical Science',
        'Counselor, Social Worker, or Other Community and Social Service Specialist',
        'Lawyer, Judge',
        'Life Scientist (e.g., Animal, Food, Soil, or Biological Scientist, Zoologist)',
        'Physical Scientist (e.g., Astronomer, Physicist, Chemist, Hydrologist)',
        'Religious Worker (e.g., Clergy, Director of Religious Activities or Education)',
        'Social Scientist and Related Worker',
        'Other Professional Occupation',
        {'header': 'Office and Administrative Support Occupations:'},
        'Supervisor of Administrative Support Workers',
        'Financial Clerk',
        'Secretary or Administrative Assistant',
        'Material Recording, Scheduling, and Dispatching Worker',
        'Other Office and Administrative Support Occupation',
        {'header': "Services Occupations:"},
          'Protective Service (e.g., Fire Fighting, Police Officer, Correctional Officer)',
          'Chef or Head Cook',
          'Cook or Food Preparation Worker',
          'Food and Beverage Serving Worker (e.g., Bartender, Waiter, Waitress)',
          'Building and Grounds Cleaning and Maintenance',
          'Personal Care and Service (e.g., Hairdresser, Flight Attendant, Concierge)',
          'Sales Supervisor, Retail Sales',
          'Retail Sales Worker',
          'Insurance Sales Agent',
          'Sales Representative',
          'Real Estate Sales Agent',
          'Other Services Occupation',
        {'header': "Agriculture, Maintenance, Repair, and Skilled Crafts Occupations:"},
          'Construction and Extraction (e.g., Construction Laborer, Electrician)',
          'Farming, Fishing, and Forestry',
          'Installation, Maintenance, and Repair',
          'Production Occupations',
          'Other Agriculture, Maintenance, Repair, and Skilled Crafts Occupation',
        {'header': "Transportation Occupations:"},
          'Aircraft Pilot or Flight Engineer',
          'Motor Vehicle Operator (e.g., Ambulance, Bus, Taxi, or Truck Driver)',
          'Other Transportation Occupation',
        {'header': "Other Occupations:"},
          'Military',
          'Homemaker',
          'Other Occupation',
          "Don't Know",
          'Not Applicable',
      ],
      occupationRules: [
        v => !!v || 'Occupation is required',
      ],
      age: '',
      ageRules: [
        v => !!v || 'Age is required',
        v => !!v && v > 0 || 'Age is invalid',
      ],
      company: '',
      industry: null,
      industries: ['Mass Media', 'Leisure', 'Video Editing', 'E-commerce', 'Entertainment', 'Information Technology', 'Electronics', 'Others', 'Hospitality', 'Healthcare', 'Agriculture', 'Beverage', 'Energy', 'Food', 'Internet', 'Sport', 'Human Resource (HR)', 'Finance', 'Digital Marketing', 'Construction', 'Transport', 'Artificial Intelligence', 'Education', 'Computer Hardware', 'Service', 'Software', 'Freelancing', 'Automotive', 'Telecommunication', 'Video on Demand (VOD)', 'Real Estate', 'Aerospace', 'Graphic Design', 'Travel', 'Financial Services'],
      nationality: '',
      nationalities: ['Afghan', 'Albanian', 'Algerian', 'American', 'Andorran', 'Angolan', 'Antiguans', 'Argentinean', 'Armenian', 'Australian', 'Austrian', 'Azerbaijani', 'Bahamian', 'Bahraini', 'Bangladeshi', 'Barbadian', 'Barbudans', 'Batswana', 'Belarusian', 'Belgian', 'Belizean', 'Beninese', 'Bhutanese', 'Bolivian', 'Bosnian', 'Brazilian', 'British', 'Bruneian', 'Bulgarian', 'Burkinabe', 'Burmese', 'Burundian', 'Cambodian', 'Cameroonian', 'Canadian', 'Cape Verdean', 'Central African', 'Chadian', 'Chilean', 'Chinese', 'Colombian', 'Comoran', 'Congolese', 'Costa Rican', 'Croatian', 'Cuban', 'Cypriot', 'Czech', 'Danish', 'Djibouti', 'Dominican', 'Dutch', 'East Timorese', 'Ecuadorean', 'Egyptian', 'Emirian', 'Equatorial Guinean', 'Eritrean', 'Estonian', 'Ethiopian', 'Fijian', 'Filipino', 'Finnish', 'French', 'Gabonese', 'Gambian', 'Georgian', 'German', 'Ghanaian', 'Greek', 'Grenadian', 'Guatemalan', 'Guinea-Bissauan', 'Guinean', 'Guyanese', 'Haitian', 'Herzegovinian', 'Honduran', 'Hungarian', 'I-Kiribati', 'Icelander', 'Indian', 'Indonesian', 'Iranian', 'Iraqi', 'Irish', 'Israeli', 'Italian', 'Ivorian', 'Jamaican', 'Japanese', 'Jordanian', 'Kazakhstani', 'Kenyan', 'Kittian and Nevisian', 'Kuwaiti', 'Kyrgyz', 'Laotian', 'Latvian', 'Lebanese', 'Liberian', 'Libyan', 'Liechtensteiner', 'Lithuanian', 'Luxembourger', 'Macedonian', 'Malagasy', 'Malawian', 'Malaysian', 'Maldivian', 'Malian', 'Maltese', 'Marshallese', 'Mauritanian', 'Mauritian', 'Mexican', 'Micronesian', 'Moldovan', 'Monacan', 'Mongolian', 'Moroccan', 'Mosotho', 'Motswana', 'Mozambican', 'Namibian', 'Nauruan', 'Nepalese', 'New Zealander', 'Ni-Vanuatu', 'Nicaraguan', 'Nigerian', 'Nigerien', 'North Korean', 'Northern Irish', 'Norwegian', 'Omani', 'Pakistani', 'Palauan', 'Panamanian', 'Papua New Guinean', 'Paraguayan', 'Peruvian', 'Polish', 'Portuguese', 'Qatari', 'Romanian', 'Russian', 'Rwandan', 'Saint Lucian', 'Salvadoran', 'Samoan', 'San Marinese', 'Sao Tomean', 'Saudi', 'Scottish', 'Senegalese', 'Serbian', 'Seychellois', 'Sierra Leonean', 'Singaporean', 'Slovakian', 'Slovenian', 'Solomon Islander', 'Somali', 'South African', 'South Korean', 'Spanish', 'Sri Lankan', 'Sudanese', 'Surinamer', 'Swazi', 'Swedish', 'Swiss', 'Syrian', 'Taiwanese', 'Tajik', 'Tanzanian', 'Thai', 'Togolese', 'Tongan', 'Trinidadian or Tobagonian', 'Tunisian', 'Turkish', 'Tuvaluan', 'Ugandan', 'Ukrainian', 'Uruguayan', 'Uzbekistani', 'Venezuelan', 'Vietnamese', 'Welsh', 'Yemenite', 'Zambian', 'Zimbabwean'],
      nationalityRules: [
        v => !!v || 'Nationality is required',
      ],
      sendButtonClick: false,
      password: '',
      passShow: false,
      confirmPassword: '',
      confirmShow: false,
      error: false,
      error_type: null,
      info_message: "Please fill in your profile's info:",
      dont_match: false,
    }),

    computed: {
      ...mapState({
        user: (state) => state.account.user,
        isAccountCreating: (state) => state.loader.loading,
        error_message: (state) => state.account.message,
      }),
      bgHeight() {
        return this.$vuetify.breakpoint.height
      },
      bgWidth() {
        return this.$vuetify.breakpoint.width
      },
      cardWidth () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return 94
          case 'sm': return 84
          case 'md': return 78
          case 'lg': return 73
          case 'xl': return 73
          default: return 73
        }
      },
      rules () {
        const rules = []
        const rule =
          v => (!!v && v) === this.password ||
            "Passwords don't match"
        rules.push(rule)
        return rules
      },
      passwordRules() {
        return [
          v => !!v || 'Password is Required.',
          v => v.length >= 6 || 'Min 6 characters',
        ]
      },
    },
    mounted() {
      store.commit(`account/${SET_USER}`, null);
    },
    watch: {
      password: 'validateConfirmField',
    },

    methods: {
      ...mapActions("account", [
        REGISTER,
      ]),
      submit() {
        this.sendButtonClick = true;
        if (!this.validateForm()){
          window.scrollTo({ top: 0, left: 0, behavior: 'smooth'});
          if (this.$refs.confirmPassword && this.$refs.confirmPassword.hasError){
            setTimeout( () => {
              this.sendButtonClick = false;
              this.valid = true;
              this.set_error('password', "Passwords don't match");
            }, 300);
          }
          else{
            setTimeout( () => {
              this.sendButtonClick = false;
              this.set_error('other', 'Please fill in all the fields:');
            }, 300);
          }
          return;
        }
        let userData = {
          firstName: this.firstName,
          lastName: this.lastName,
          email: this.email,
          occupation: this.occupation,
          age: this.age,
          company: this.company,
          industry: this.industry,
          nationality: this.nationality,
          password: this.password,
        }
        this.REGISTER({ userData }).then(
          (response) => {
            this.clear_error();
            this.sendButtonClick = false;
            if (response) {
              this.$router.push('/register-success');
            }
          },
          (error) => {
            this.set_error('email', this.error_message);
            this.sendButtonClick = false;
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth'});
          }
        );
      },
      validateConfirmField(){
        if(this.confirmPassword && this.password === this.confirmPassword){
         this.validateForm();
        }
      },
      set_error(type=null, message){
        this.error=true;
        this.error_type=type;
        this.info_message=message;
      },
      clear_error(){
        this.error=false;
        this.error_type=null;
        this.info_message='';
      },
      validateForm() {
        return this.$refs.form.validate();
      },
    },
  }
</script>

<style scoped>
.robot{
  position: absolute;
  z-index: 1;
  left: 0;
  right: 0;
  margin: auto;
  top: -8%;
}
.form-custom{
  margin-left: 9% !important;
  margin-right: 9% !important;
  width: 82% !important;
}

.welcome{
  color: #286577;
  font-weight: 800;
}

.message{
  font-weight: 500;
}

.welcome_in{
  opacity: 0;
  transform: translateX(0%);
  animation: welcome-in-anim .7s ease-out forwards;
}

.message_in{
  transform: translateX(-15%);
  animation: message-in-anim .7s ease-out forwards;
  opacity: 0;
}

@keyframes welcome-in-anim {
  20% {
    opacity: 0;
    transform: translateX(-20%);
  }
  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}

.welcome_out{
  opacity: 1;
  transform: translateX(0%);
  animation: welcome-out-anim .4s ease-out forwards;
}

@keyframes welcome-out-anim {
  20% {
    opacity: 1;
    transform: translateX(0%);
  }
  100% {
    opacity: 0;
    transform: translateX(30%);
  }
}

@keyframes message-in-anim {
  20% {
    opacity: 0;
    transform: translateX(-15%);
  }

  100% {
    opacity: 1;
    transform: translateX(0%);
  }
}

.message_out{
  opacity: 1;
  transform: translateX(0%);
  animation: message-out-anim .4s ease-out forwards;
}

@keyframes message-out-anim {
  20% {
    opacity: 1;
    transform: translateX(0%);
  }

  60% {
    opacity: .7;
    transform: translateX(6%);
  }

  100% {
    opacity: 0;
    transform: translateX(12%);
  }
}

.v-menu__content{
  width: 45% !important;
}

.card-shadow{
  box-shadow: 4px 4px #000033;
}

.v-input__slot input {
  direction: rtl;
}

.v-btn--outlined {
  border: 3px solid black;
  background-color: #F9F7FE;
}

.input--dense{
  height: 60px !important;
}

.v-input--is-focused .v-input__slot {
  border: 2px solid black !important;
  border-bottom-color: black !important;
}

.button-font{
  font-size: 22px;
  font-weight: 500 !important;
}

</style>
